import { format, parseISO } from "date-fns";

import { resolveJapaneseFormat } from "./formatLocalizedDate";

import { LanguageType } from "types/index";
import { DEFAULT_VALUE, LANGUAGE_MAP } from "constants/index";

/**
 * BE sends JST datetime but incorrectly marks it as UTC (Z / +00:00).
 * This function removes the UTC marker WITHOUT applying any timezone conversion.
 **/

const normalizeJSTStringFromBE = (value: string): string => {
  return value.replace(/(Z|\+00:00)$/, "");
};

export const formatJSTDateFromBE = (
  value: string | null,
  language: LanguageType,
  fallbackFormat: string = DEFAULT_VALUE.DATE_TIME_FORMAT_WITHOUT_SECONDS
): string => {
  if (!value) return "-";

  const normalizedValue = normalizeJSTStringFromBE(value);

  const parsedDate = parseISO(normalizedValue);

  if (Number.isNaN(parsedDate.getTime())) return "-";

  const formatString =
    language === LANGUAGE_MAP.JA
      ? resolveJapaneseFormat(fallbackFormat)
      : fallbackFormat;

  return format(parsedDate, formatString);
};
